import { FormProvider } from "react-hook-form";
import { FormInput, FormTextarea, Heading, Loader } from "@/components";
import { Button } from "@/components/ui";
import { AddEditMasterModuleLayoutProps } from "./types";

const AddEditMasterModuleLayout = ({
  hookResult,
  nameLabel = "Name",
  descLabel = "Description",
  customFields,
  hideDesc = false
}: AddEditMasterModuleLayoutProps) => {
  const {
    breadcrumbData,
    onBackClick,
    form,
    onSubmit,
    requiredFields,
    isAddPending,
    isUpdatePending,
    onCancel,
    isRecordLoading,
    nameFieldKey,
    descFieldKey,
    isView,
  } = hookResult;

  const { errors } = form.formState;
  const isSubmitting = isAddPending || isUpdatePending;

  return (
    <div className="p-4 md:p-6">
      <Heading
        title={breadcrumbData[breadcrumbData.length - 1]?.name}
        showBack
        breadcrumbData={breadcrumbData}
        onBackClick={onBackClick}
      />

      {isRecordLoading ? (
        <Loader />
      ) : (
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px]">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-[30px]">
                <div>
                  <FormInput
                    name={nameFieldKey}
                    control={form.control}
                    label={nameLabel}
                    placeholder="Please enter"
                    error={errors[nameFieldKey]?.message as string}
                    isRequired={requiredFields.includes(nameFieldKey)}
                    disabled={isView}
                  />
                </div>
                {customFields}
                {hideDesc ? <></> : <FormTextarea
                  name={descFieldKey}
                  control={form.control}
                  label={descLabel}
                  placeholder="Please enter"
                  error={errors[descFieldKey]?.message as string}
                  isRequired={requiredFields.includes(descFieldKey)}
                  disabled={isView}
                />}
              </div>
            </div>

            <div className="flex flex-row justify-end gap-3 py-3">
              <Button
                variant="outline"
                type="button"
                onClick={onCancel}
                disabled={isSubmitting}
              >
                {isView ? "Back" : "Cancel"}
              </Button>
              {!isView && (
                <Button type="submit" disabled={isSubmitting}>
                  {isSubmitting && <Loader variant="secondary" />}
                  Save
                </Button>
              )}
            </div>
          </form>
        </FormProvider>
      )}
    </div>
  );
};

export default AddEditMasterModuleLayout;